'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSwitchVideo = function MdSwitchVideo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 25.9l5.9-5.9-5.9-5.9v4.3h-10v-4.3l-5.7 5.9 5.7 5.9v-4.3h10v4.3z m8.4-10l6.6-6.8v21.8l-6.6-6.8v5.9c0 0.9-0.7 1.6-1.6 1.6h-23.4c-0.9 0-1.6-0.7-1.6-1.6v-20c0-0.9 0.7-1.6 1.6-1.6h23.4c0.9 0 1.6 0.7 1.6 1.6v5.9z' })
        )
    );
};

exports.default = MdSwitchVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/switch-video.js
// module id = 1250
// module chunks = 0